<a *ngIf="videoLink" target="_blank" [href]="videoLink">
  <i class="fa fa-2x fa-question-circle" aria-hidden="true"></i>
</a>
